module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module-manage"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("市场专题")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("模块管理")])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "special-head"
  }, [_c('div', {
    slot: "header"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("市场专题列表")])]), _vm._v(" "), _c('div', {
    staticClass: "special-select"
  }, [_c('span', [_vm._v("专题选择")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.selectSpecial
    },
    model: {
      value: (_vm.specialId),
      callback: function($$v) {
        _vm.specialId = $$v
      },
      expression: "specialId"
    }
  }, _vm._l((_vm.specialList), function(item) {
    return _c('el-option', {
      key: item.specialId,
      attrs: {
        "label": item.specialName,
        "value": item.specialId
      }
    })
  }))], 1)]), _vm._v(" "), (_vm.specialId) ? _c('el-card', {
    staticClass: "add-module"
  }, [_c('div', {
    slot: "header"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("添加模块")])]), _vm._v(" "), _c('div', {
    staticClass: "module-add-box"
  }, [_c('el-form', {
    ref: "addModuleForm",
    staticClass: "addSpecialForm",
    attrs: {
      "model": _vm.addModuleForm,
      "rules": _vm.validateRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "模块名称",
      "prop": "moduleName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入模块名称"
    },
    model: {
      value: (_vm.addModuleForm.moduleName),
      callback: function($$v) {
        _vm.addModuleForm.moduleName = $$v
      },
      expression: "addModuleForm.moduleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模块描述",
      "prop": "moduleContent"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off",
      "placeholder": "请输入模块描述（选填）"
    },
    model: {
      value: (_vm.addModuleForm.moduleContent),
      callback: function($$v) {
        _vm.addModuleForm.moduleContent = $$v
      },
      expression: "addModuleForm.moduleContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "背景图（尺寸640*64）",
      "prop": "bgImage"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入图片链接（选填）"
    },
    model: {
      value: (_vm.addModuleForm.bgImage),
      callback: function($$v) {
        _vm.addModuleForm.bgImage = $$v
      },
      expression: "addModuleForm.bgImage"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addModuleSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clearModuleFormData
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.specialId) ? _c('el-card', {
    staticClass: "modules"
  }, [_c('div', {
    slot: "header"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("已有模块")])]), _vm._v(" "), _c('el-table', {
    staticClass: "module-list",
    attrs: {
      "data": _vm.moduleList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "moduleId",
      "label": "模块ID",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "moduleName",
      "label": "模块名称",
      "align": "center",
      "width": "240"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模块背景图",
      "align": "center",
      "width": "300"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [(scope.row.bgImage) ? _c('img', {
          staticClass: "module-bg",
          attrs: {
            "src": scope.row.bgImage,
            "alt": "模块背景图"
          }
        }) : _c('p', [_vm._v("无背景图")])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isTop",
      "label": "置顶权重",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "min-width": "220"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button-group', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "info"
          },
          on: {
            "click": function($event) {
              _vm.goTopModule(scope.row.moduleId)
            }
          }
        }, [_vm._v("置顶")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.deleteModule(scope.row.moduleId)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": function($event) {
              _vm.editModule(scope.row)
            }
          }
        }, [_vm._v("编辑")])], 1)]
      }]
    ])
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑-模块",
      "visible": _vm.dialogFormVisible
    }
  }, [_c('el-form', {
    ref: "editModuleForm",
    staticClass: "addSpecialForm",
    attrs: {
      "model": _vm.editModuleForm,
      "rules": _vm.validateRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "模块名称",
      "prop": "moduleName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入模块名称"
    },
    model: {
      value: (_vm.editModuleForm.moduleName),
      callback: function($$v) {
        _vm.editModuleForm.moduleName = $$v
      },
      expression: "editModuleForm.moduleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模块描述",
      "prop": "moduleContent"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off",
      "placeholder": "请输入模块描述（选填）"
    },
    model: {
      value: (_vm.editModuleForm.moduleContent),
      callback: function($$v) {
        _vm.editModuleForm.moduleContent = $$v
      },
      expression: "editModuleForm.moduleContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "背景图（尺寸640*64）",
      "prop": "bgImage"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入图片链接（选填）"
    },
    model: {
      value: (_vm.editModuleForm.bgImage),
      callback: function($$v) {
        _vm.editModuleForm.bgImage = $$v
      },
      expression: "editModuleForm.bgImage"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-btn-group"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2453d15e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/market/Module.vue
// module id = 742
// module chunks = 1